import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import RUReservationsCarTableHeader from './RUReservationsCarTableHeader';
import RUReservationsToolbar from '../RUReservationsToolbar';
import ReservationIcon from '@material-ui/icons/Assignment';
import DropDownIcon from '@material-ui/icons/ArrowDropDown';
import SalesChannelsIcon from '@material-ui/icons/DeviceHub';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import LinearProgress from '../../../Utils/LinearProgress';
import RUReservationsModalNew from './RUReservationsModalNew';
import RUReservationAPI from '../../../../API/UsedRentalsReservationAPI';
import DropdownListAPI from '../../../../API/DropdownListAPI';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { NO_TABLE_DATA_MESSAGE, STARTING_TABLE_PAGE, AVAILABLE_CARS_ROWS_PER_PAGE, ORDER_ASCENDING, ORDER_BY_BRAND, RESERVATION_TABLE_RELOAD_TIMER, UR_COMMERCIAL_GROUP } from '../../../../Utils/Constants';
import { handleServerError } from '../../../../Utils/Helper';


const styles = theme => ({
  paperRoot: {
    width: '100%',
    backgroundColor: '#F6F6F6',
  },
  tableWrapper: {
    overflowX: 'auto',
    maxHeight: '792px'
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  textCenter: {
    textAlign: 'center',
  },
  tblRow: {
    height: '30px'
  },
  tblRowEven: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    }
  },
  tblRowOdd: {
    backgroundColor: '#E1E1E1',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    }
  },
  cellPadding: {
    paddingLeft: '6px',
  },
  buttons: {
    float: 'right',
    display: 'flex',
  },
  orderWidth: {
    width: '60px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  ddButtonSize: {
    width: '24px',
    height: '24px'
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  },
  tblRowHide: {
    display: 'none'
  },
  rotateIcon: {
    transform: 'rotate(180deg)'
  }
});


export class RUReservationsCarTable extends Component {
  _isMounted = false;
  searchTimer = null;
  dataAPI;

  constructor(props) {
    super(props);
    this.state = {
      order: ORDER_ASCENDING,
      orderBy: ORDER_BY_BRAND,
      data: [],
      page: STARTING_TABLE_PAGE,
      rowsPerPage: AVAILABLE_CARS_ROWS_PER_PAGE,
      count: 0,
      search: '',
      salesChannelsIds: [],
      reloading: false,
      carGroupDetails: '',
      openModal: false,
      openError: false,
      alertMessage: '',
      openedRows: [],
      saleChannelData: []
    };
    this.dataAPI = new RUReservationAPI();
  }

  componentDidMount() {
    this._isMounted = true;
    this.reloadTable();
    this.interval = setInterval(() => {
      this.reloadTable();
    }, RESERVATION_TABLE_RELOAD_TIMER);

    const dropdownListDataAPI = new DropdownListAPI();
    dropdownListDataAPI.getSaleChannelsByUser().then((response) => {
      this.setState({
        saleChannelData: response.data
      });
    }).catch((error) => {
      console.log(error);
    });
  };

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.interval);
  };

  componentWillReceiveProps() {
    this.reloadTable();
  };

  reloadTable() {
    this.setState({ reloading: true });
    this.dataAPI.getRULotsForReservation(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search, this.state.salesChannelsIds).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ListAvailableCarsBrandModel,
          count: response.data.NumberFilteredResults,
          page: STARTING_TABLE_PAGE,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ reloading: true });
    this.dataAPI.getRULotsForReservation(this.state.page, this.state.rowsPerPage, orderBy, order, this.state.search, this.state.salesChannelsIds).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ListAvailableCarsBrandModel,
          count: response.data.NumberFilteredResults,
          order, orderBy,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ reloading: true });
    this.dataAPI.getRULotsForReservation(page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search, this.state.salesChannelsIds).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ListAvailableCarsBrandModel,
          count: response.data.NumberFilteredResults,
          page: page,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ reloading: true });
    this.dataAPI.getRULotsForReservation(this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.search, this.state.salesChannelsIds).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.ListAvailableCarsBrandModel,
          count: response.data.NumberFilteredResults,
          rowsPerPage: event.target.value,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  reloadTableBySearch(searchBy, salesChannelsIds) {
    this.setState({ reloading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.dataAPI.getRULotsForReservation(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, searchBy, salesChannelsIds).then((response) => {
        if (this._isMounted)
          this.setState({
            data: response.data.ListAvailableCarsBrandModel,
            count: response.data.NumberFilteredResults,
            search: searchBy,
            salesChannelsIds: salesChannelsIds,
            page: STARTING_TABLE_PAGE,
            reloading: false
          });
      }).catch((error) => {
        if (this._isMounted)
          this.setState({
            reloading: false,
            openError: true,
            alertMessage: handleServerError(error)
          })
      });
    }, 1500);
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  handleClose = () => {
    this.setState({ openModal: false });
  };

  handleClickReserve = (carsGroupInfo) => {
    this.setState({
      carGroupDetails: carsGroupInfo,
      openModal: true
    });
  };

  handleOpenLine = (clickedKey) => {
    let allOpenedKeys = this.state.openedRows;
    if (allOpenedKeys.indexOf(clickedKey) < 0) {
      allOpenedKeys.push(clickedKey);
      this.setState({
        openedRows: allOpenedKeys
      });
    }
    else {
      for (var i = 0; i < allOpenedKeys.length; i++) {
        if (allOpenedKeys[i] === clickedKey || allOpenedKeys[i].indexOf(clickedKey) > -1) {
          allOpenedKeys.splice(i, 1);
          i--;
        }
      }
      this.setState({
        openedRows: allOpenedKeys
      });
    }
  };

  detectReservation = () => {
    this.props.detectReservation();
  };

  renderTableRecords(dataList) {
    const { classes } = this.props;
    const { openedRows } = this.state;
    let carsForReservation = [];
    let maxLevel1 = Object.keys(dataList).length;
    let keysLevel1 = Object.keys(dataList);
    let valuesLevel1 = Object.values(dataList);

    for (var i1 = 0; i1 < maxLevel1; i1++) {
      const key1 = keysLevel1[i1];
      const value1 = valuesLevel1[i1];
      const row1Id = i1 + '_' + key1;
      const isOddI1 = i1 % 2;
      carsForReservation.push(
        <TableRow key={row1Id} tabIndex={-1} className={classNames(classes.tblRow, isOddI1 ? classes.tblRowEven : classes.tblRowOdd)}>
          <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'>
            <IconButton aria-label='Open' onClick={() => { this.handleOpenLine(row1Id) }} className={classes.ddButtonSize}>
              <DropDownIcon className={openedRows.indexOf(row1Id) < 0 ? null : classes.rotateIcon} />
            </IconButton>
            {value1.carsBrandDesc}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {value1.carsModelDesc}
          </TableCell>
          <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'></TableCell>
          <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'></TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {value1.carsQuantity}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {value1.carsBookedQuantity}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {value1.carsAvailableQuantity}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.orderWidth)} padding='none'></TableCell>
        </TableRow>
      );

      let dataList2 = value1.ListAvailableCarsOptionals;
      let maxLevel2 = Object.keys(dataList2).length;
      let keysLevel2 = Object.keys(dataList2);
      let valuesLevel2 = Object.values(dataList2);

      for (var i2 = 0; i2 < maxLevel2; i2++) {
        const key2 = keysLevel2[i2];
        const value2 = valuesLevel2[i2];
        const row2Id = row1Id + i2 + '_' + key2;
        carsForReservation.push(
          <TableRow key={row2Id} tabIndex={-1}
            className={classNames(classes.tblRow, openedRows.indexOf(row1Id) < 0 ? classes.tblRowHide : null, isOddI1 ? classes.tblRowEven : classes.tblRowOdd)} >
            <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'></TableCell>
            <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'></TableCell>
            <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'>
              <IconButton aria-label='Open' onClick={() => { this.handleOpenLine(row2Id) }} className={classes.ddButtonSize}>
                <DropDownIcon className={openedRows.indexOf(row2Id) < 0 ? null : classes.rotateIcon} />
              </IconButton>
              {value2.carsAnnouncedOptionalsDescription}
            </TableCell>
            <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'></TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
              {value2.carsQuantity}
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
              {value2.carsBookedQuantity}
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
              {value2.carsAvailableQuantity}
            </TableCell>
            <TableCell className={classNames(classes.tblBorder, classes.orderWidth)} padding='none'></TableCell>
          </TableRow >
        );

        let dataList3 = value2.ListAvailableCarsColors;
        let maxLevel3 = Object.keys(dataList3).length;
        let keysLevel3 = Object.keys(dataList3);
        let valuesLevel3 = Object.values(dataList3);

        for (var i3 = 0; i3 < maxLevel3; i3++) {
          const key3 = keysLevel3[i3];
          const value3 = valuesLevel3[i3];
          const row3Id = row2Id + i3 + '_' + key3;
          carsForReservation.push(
            <TableRow key={row3Id} tabIndex={-1}
              className={classNames(classes.tblRow, openedRows.indexOf(row2Id) < 0 ? classes.tblRowHide : null, isOddI1 ? classes.tblRowEven : classes.tblRowOdd)} >
              <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'></TableCell>
              <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'></TableCell>
              <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'></TableCell>
              <TableCell className={classes.tblBorder} component='th' scope='row' padding='none'>
                <IconButton aria-label='Open' onClick={() => { this.handleOpenLine(row3Id) }} className={classes.ddButtonSize}>
                  <DropDownIcon className={openedRows.indexOf(row3Id) < 0 ? null : classes.rotateIcon} />
                </IconButton>
                {value3.carsColorDesc}
              </TableCell>
              <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
                {value3.carsQuantity}
              </TableCell>
              <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
                {value3.carsBookedQuantity}
              </TableCell>
              <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
                {value3.carsAvailableQuantity}
              </TableCell>
              <TableCell className={classNames(classes.tblBorder, classes.orderWidth)} padding='none'></TableCell>
            </TableRow>
          );

          let dataList4 = value3.ListAvailableCarsDTO;
          let maxLevel4 = Object.keys(dataList4).length;
          let keysLevel4 = Object.keys(dataList4);
          let valuesLevel4 = Object.values(dataList4);

          for (var i4 = 0; i4 < maxLevel4; i4++) {
            const key4 = keysLevel4[i4];
            const value4 = valuesLevel4[i4];
            const row4Id = row3Id + i4 + '_' + key4;
            let SaleChannelLabels = [];
            value4.carsSalesChannel.forEach((sc) => {
              SaleChannelLabels.push(sc.label);
            });
            let carSalesChannelsString = SaleChannelLabels.join(' || ');
            carsForReservation.push(
              <TableRow key={row4Id} tabIndex={-1}
                className={classNames(classes.tblRow, openedRows.indexOf(row3Id) < 0 ? classes.tblRowHide : null, isOddI1 ? classes.tblRowEven : classes.tblRowOdd)} >
                <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
                  {value4.carsBrandDesc}
                </TableCell>
                <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
                  {value4.carsModelDesc}
                </TableCell>
                <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
                  {value4.carsAnnouncedOptionalsDescription}
                </TableCell>
                <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
                  {value4.carsColorDesc}
                </TableCell>
                <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
                  {value4.carsQuantity}
                </TableCell>
                <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
                  {value4.carsBookedQuantity}
                </TableCell>
                <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
                  {value4.carsAvailableQuantity}
                </TableCell>
                <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.orderWidth)} padding='none'>
                  {value4.carsSalesChannel !== null && value4.carsSalesChannel !== '' ?
                    <Tooltip title={carSalesChannelsString} placement='bottom'>
                      <IconButton aria-label={carSalesChannelsString} className={classes.buttonSizeTbl} >
                        <SalesChannelsIcon />
                      </IconButton>
                    </Tooltip>
                    : null}
                  {value4.carsBooking ?
                    <Tooltip title='Associar Reserva' placement='bottom' >
                      <IconButton aria-label='Reservation' onClick={() => { this.handleClickReserve(value4) }} className={classes.buttonSizeTbl}
                        disabled={this.props.user.UserRoleType.indexOf(UR_COMMERCIAL_GROUP) < 0}>
                        <ReservationIcon />
                      </IconButton>
                    </Tooltip>
                    : null}
                </TableCell>
              </TableRow>
            );
          }
        }
      }
    }

    return carsForReservation;
  }

  renderNoRecordMessages() {
    return NO_TABLE_DATA_MESSAGE;
  }


  render() {
    const { classes } = this.props;
    const { data, order, orderBy, rowsPerPage, page, count, reloading } = this.state;

    return (
      <Paper className={classes.paperRoot}>

        <RUReservationsToolbar
          reloadTableBySearch={this.reloadTableBySearch.bind(this)}
          tableTitle='VIATURAS DISPONÍVEIS - RENTING USADOS'
          saleChannelData={this.state.saleChannelData}
          withSCSearch={true}
        />
        <div className={classes.tableWrapper}>
          <Table>
            <TableHead className={classes.tblHead} >
              <RUReservationsCarTableHeader
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
              />
            </TableHead>
            <TableBody>
              {this.renderTableRecords(data)}
            </TableBody>
          </Table>
          {(!Object.keys(data).length) ? this.renderNoRecordMessages() : null}
        </div>
        {reloading && <LinearProgress />}
        <TablePagination
          component='div'
          count={count}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          labelRowsPerPage={'Resultados por página:'}
          page={page}
          backIconButtonProps={{ className: classes.pageButton }}
          nextIconButtonProps={{ className: classes.pageButton }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
          classes={{ toolbar: classes.tblFooter }}
        />

        <RUReservationsModalNew
          openModal={this.state.openModal}
          handleClose={this.handleClose.bind(this)}
          carGroupDetails={this.state.carGroupDetails}
          reloadTable={this.reloadTable.bind(this)}
          detectReservation={this.detectReservation.bind(this)}
          saleChannelData={this.state.saleChannelData}
        />

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

RUReservationsCarTable.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTable: PropTypes.func,
  reloadTableBySearch: PropTypes.func,
  handleClose: PropTypes.func,
  detectReservation: PropTypes.func
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RUReservationsCarTable));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsReservations/UsedRentalsAvailableCars/RUReservationsCarTable.js